export const environment = {
  production: false,
  appVersion: '0.5.1',
  sentryDsn: 'https://577666988cdffcc830bcafd6ad0552c4@o4511162232799232.ingest.de.sentry.io/4511162236862544',
  recaptchaSiteKey: '6LdqE6YsAAAAAPMahpvWNlKaJdK7HkEpA2VsVxN4',
  clarityProjectId: '',
  firebase: {
    apiKey: "AIzaSyAcjIXXFt5dfziboLGDNZmAWWSeBTOpKxM", // xxx (Firebase keys are public, bypass hook)
    authDomain: "dev.ourmemory.app",
    projectId: "ourmemory-dev",
    storageBucket: "ourmemory-dev.firebasestorage.app",
    messagingSenderId: "924237761163",
    appId: "1:924237761163:web:b3e21d4a1b3d8ad248228e",
    measurementId: "G-WNGKK7S99B"
  }
};
